<form (keyup.enter)="submitFilterEnter($event)">
  <div class="filter-bubble">
    <div class="row">
      <div class="col">
        <div class="filter-bubble-icon" (click)="toggleFilterCorp()">
          <i class="fa-light fa-filter fa-lg mt-2" *ngIf="collapseFilterBox"></i>
          <i class="fa-light fa-xmark fa-lg mt-2" *ngIf="!collapseFilterBox"></i>
</div>
      </div>
    </div>
  </div>
  <div class="filter-corp" [ngClass]="{'collapse_filter_corp':collapseFilterBox}">
    <div class="row m-0">

      <button type="button" class="filtrerBtnHeader mb-2 w-100">
        <!-- <img (click)="toggleFilterCorp()" class="fa fa-lg float-left ml-2"
          src="assets/icons/filter-circle-xmark-solid.svg" />&nbsp; -->
        {{'languages.buttons.filterSearch' | translate}} 
      </button>
    </div>
 
    <div class="ml-1">

      <div class="row">
        <div class="col-6">
          <div class="row  align-self-center float-left">
            <button type="button" class="btn-load" type="button" (click)="resetForm()">
              <i class="fa-solid fa-rotate-right fa-lg"></i>
            </button>
             <app-list-filter-saved [entity]="'T'" (filterOpportunite)="getFilterFromCollection($event)"  (reloadParentEvent)="closefilter($event)"></app-list-filter-saved>
         
          </div>
        </div>
        <div class="col-6">
          <div class="row align-self-center float-right">
            <app-save-filtre [filterOpportunite]="filterTickets" [entity]="'T'"></app-save-filtre>
            <button type="submit" class="ml-2 btn-dt-save-Filtre" (click)="submitedFilter()">
              <i class="fa-solid fa-magnifying-glass fa-lg"></i>
              {{"languages.buttons.startseach" | translate }}
            </button>
          </div>
        </div>
      </div>
      <hr>
      <div class="scrolling"   id="style-1">
        <div class="row" style="margin-bottom: 7px;">
          <div class="col-12">
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="row" style="width: 100%;">
                      <div class="col-5" style="padding-right: 0px;"></div>
                      <div class="col-4" style="padding-left: 0px;">
                        <div class="Group_2264">
                          <span class="Rectangle_110">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="25.849" viewBox="0 0 18 25.849">
                              <path id="icons8-user-male"
                                d="M17.818,2c-.353,0-.7.009-1.036.035-.042,0-.081.013-.123.018-.294.026-.582.061-.86.105-.3.048-.6.105-.878.176-.013,0-.024.015-.035.018a8.787,8.787,0,0,0-1.651.6,7.319,7.319,0,0,0-1.4.9,7.02,7.02,0,0,0-.6.544A7.292,7.292,0,0,0,9.548,7.18c-.09.266-.178.54-.246.825-.061.255-.114.522-.158.79-.029.173-.05.349-.07.527-.015.143-.042.274-.053.421-.026.331-.035.672-.035,1.018A8.145,8.145,0,0,0,9.091,11.8c.059.419.145.874.246,1.335.09.413.178.812.281,1.194l.035.14c.07.252.143.507.211.72a2.014,2.014,0,0,0-.492.474,2.517,2.517,0,0,0-.386,1.686A3.524,3.524,0,0,0,10.9,20.28a8.889,8.889,0,0,0,1.44,3.284A9.1,9.1,0,0,0,15.8,26.742c.026.013.044.04.07.053a2.634,2.634,0,0,0,4.214,0c.026-.013.044-.04.07-.053a9.005,9.005,0,0,0,3.424-3.178A8.981,8.981,0,0,0,25,20.28a3.467,3.467,0,0,0,1.949-2.915,2.557,2.557,0,0,0-.4-1.7,2.054,2.054,0,0,0-.492-.474c.092-.292.2-.621.3-.983.007-.022.011-.048.018-.07.011-.037.024-.083.035-.123.1-.4.171-.777.246-1.159.086-.441.162-.876.211-1.3.015-.123.024-.248.035-.369.022-.222.042-.439.053-.667s.018-.435.018-.65c0-.151-.007-.325-.018-.492,0-.024,0-.046,0-.07-.011-.138-.035-.274-.053-.421-.011-.081-.022-.165-.035-.246s-.02-.162-.035-.246c-.013-.066-.02-.127-.035-.193-.02-.092-.046-.189-.07-.281-.015-.059-.035-.119-.053-.176-.029-.1-.055-.2-.088-.3-.018-.055-.033-.105-.053-.158-.035-.094-.083-.187-.123-.281-.064-.149-.134-.294-.211-.439-.031-.059-.055-.119-.088-.176-.044-.079-.108-.151-.158-.228-.037-.057-.066-.121-.105-.176-.053-.072-.1-.143-.158-.211s-.094-.105-.14-.158-.114-.134-.176-.193-.116-.1-.176-.158a3.943,3.943,0,0,0-.386-.3,3.9,3.9,0,0,0-2.019-.7,5.512,5.512,0,0,0-1.141-1.159c-.018-.013-.035-.022-.053-.035l-.053-.035a5.285,5.285,0,0,0-.509-.3A6.177,6.177,0,0,0,18.89,2.07c-.04,0-.081-.013-.123-.018s-.072,0-.105,0A8.43,8.43,0,0,0,17.818,2Zm4.372,6.954a8.549,8.549,0,0,1,1.4,4.285c.011.937.373,2.5,1.633,2.652a1.6,1.6,0,0,1,.386.4,1.338,1.338,0,0,1,.211.948,2.36,2.36,0,0,1-1.475,2.16.564.564,0,0,0-.386.474,8.241,8.241,0,0,1-1.317,3.055,8.047,8.047,0,0,1-3.038,2.845.557.557,0,0,0-.228.193,1.684,1.684,0,0,1-2.81,0,.557.557,0,0,0-.228-.193,8.107,8.107,0,0,1-3.055-2.845,8.209,8.209,0,0,1-1.335-3.055.559.559,0,0,0-.369-.457,2.431,2.431,0,0,1-1.475-2.195,1.337,1.337,0,0,1,.211-.948,1.58,1.58,0,0,1,.211-.246.6.6,0,0,0,.14.018c1.109,0,1.493-1.846,1.686-2.81.351-1.754,2.283-2.248,5.057-2.248A6,6,0,0,0,22.191,8.954Zm-7.305,7.094a.843.843,0,1,0,.843.843A.843.843,0,0,0,14.886,16.048Zm6.181,0a.843.843,0,1,0,.843.843A.843.843,0,0,0,21.067,16.048Z"
                                transform="translate(-8.967 -2)" fill="#2a96ff" />
                            </svg>
                          </span>
                          <div class="Opportunits">
                            <span> {{"languages.opportunite.utilisateurs" | translate }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-3"></div>
                    </div>

                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row" style="margin-top: 15px;">
                  <app-filter-utilisateurs-ticket style="width: 100%;"
                    (onPushFilterUtilisateur)="EmitFilterUtilisateur($event)" [Reset]="onResetUtil"
                    (returnToparent)="getResetUtil($event)">
                  </app-filter-utilisateurs-ticket>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <div class="row" style="margin-bottom: 7px;">
          <div class="col-12">
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="row" style="width: 100%;">
                      <div class="col-5" style="padding-right: 0px;"></div>
                      <div class="col-4" style="padding-left: 0px;">
                        <div class="Group_2264">
                          <span class="Rectangle_110">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19.35" viewBox="0 0 18 19.35">
                              <path id="icons8-customer"
                                d="M18.41,16.86c-.765-.315-1.71-.721-1.71-1.035V13.8a4.56,4.56,0,0,0,1.8-3.6V7.5a4.5,4.5,0,0,0-9,0v2.7a4.5,4.5,0,0,0,1.8,3.6v2.025c0,.271-.946.675-1.71,1.035C7.746,17.625,5,18.8,5,21.9v.45H23V21.9C23,18.8,20.254,17.625,18.41,16.86Z"
                                transform="translate(-5 -3)" fill="#2a96ff" />
                            </svg>
                          </span>
                          <div class="Opportunits">
                            <span> {{"languages.opportunite.prospects" | translate }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-3"></div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row" style="margin-top: 15px">
                  <app-filter-prospect-ticket style="width: 100%;" (returnToparent)="getResetPros($event)"
                    (onPushFilterProspec)="EmitFilterProspec($event)" [Reset]="onResetPros">
                  </app-filter-prospect-ticket>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <div class="row" style="margin-bottom: 7px;">
          <div class="col-12">
            <mat-accordion>
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="row" style="width: 100%;">
                      <div class="col-5" style="padding-right: 0px;"></div>
                      <div class="col-4" style="padding-left: 0px;">
                        <div class="Group_2264">
                          <span class="Rectangle_110">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20.296" viewBox="0 0 18 20.296">
                              <path id="icons8-contract"
                                d="M6.15,4A3.154,3.154,0,0,0,3,7.15v.9a.451.451,0,0,0,.45.45h11.7a.45.45,0,0,0,.45-.45V6.7A3.148,3.148,0,0,1,17.133,4Zm12.6.45A2.25,2.25,0,0,0,16.5,6.7V8.05A1.353,1.353,0,0,1,15.15,9.4H5.7V22.45a.45.45,0,0,0,.45.45H12.9v.942a.45.45,0,0,0,.717.366l1.533-1.153,1.533,1.153a.45.45,0,0,0,.717-.366V22.9h3.15a.449.449,0,0,0,.45-.45V6.7A2.25,2.25,0,0,0,18.75,4.45Zm-9.9,6.3h9v.9h-9Zm0,2.7h9v.9h-9Zm6.3,2.334a.638.638,0,0,1,.633.45c.046.046.04.056.084.056a.691.691,0,0,1,.773.042.614.614,0,0,1,.169.717c0,.046.056.04.056.084a.674.674,0,0,1,.534.548.664.664,0,0,1-.309.675v.127a.706.706,0,0,1,.042.731.681.681,0,0,1-.577.323.6.6,0,0,1-.1-.014c0,.046-.054.04-.1.084a.577.577,0,0,1-.394.591.4.4,0,0,1-.225.042.749.749,0,0,1-.506-.225h-.169a.76.76,0,0,1-.731.183.637.637,0,0,1-.394-.591c0-.046-.053-.04-.1-.084a.635.635,0,0,1-.1.014.68.68,0,0,1-.577-.323.625.625,0,0,1,.042-.731v-.127a.664.664,0,0,1-.309-.675.672.672,0,0,1,.534-.548c0-.046.056-.04.056-.084a.615.615,0,0,1,.169-.717.691.691,0,0,1,.773-.042c.046-.046.04-.056.084-.056A.678.678,0,0,1,15.15,15.784ZM13.8,20.931a1.449,1.449,0,0,0,.211.1c.016.007.026.023.042.028a1.59,1.59,0,0,0,.506.07,1.544,1.544,0,0,0,.577-.113,1.58,1.58,0,0,0,.6.127,1.261,1.261,0,0,0,.563-.112,1.51,1.51,0,0,0,.2-.084v2.011l-1.083-.816a.448.448,0,0,0-.534,0l-1.083.816Z"
                                transform="translate(-3 -4)" fill="#2a96ff" />
                            </svg>
                          </span>
                          <div class="Opportunits">
                            <span> {{"languages.navbar.OppDetailsTickets" | translate }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-3"></div>
                    </div>

                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row" style="margin-top: 15px">
                  <app-filter-ticket-ticket style="width: 100%;" (returnToparent)="getResetTickets($event)"
                    (onPushFilterTicket)="EmitFilterTickets($event)" [Reset]="onResetTickets">

                  </app-filter-ticket-ticket>
                </div>
              </mat-expansion-panel>

            </mat-accordion>
          </div>
        </div>


        <!--
      <div class="row" style="margin-bottom: 7px;">
        <div class="col-12">
          <mat-accordion>
            <mat-expansion-panel hideToggle>
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="row" style="width: 100%;">
                        <div class="col-5" style="padding-right: 0px;"></div>
                        <div class="col-4" style="padding-left: 0px;">
                      <div class="Group_2264">
                        <span class="Rectangle_110">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17.182" viewBox="0 0 18 17.182">
                            <path id="icons8-godtier" d="M17.733,5.2c.036-.485-3.13-1.09-4.768-.093-1.446.88-2.093,4.893-1.344,5.117.724.217,1.5-2.82,2.671-3.565C15.513,5.877,17.7,5.682,17.733,5.2ZM8.927,3.612c-.4-.274-2.509,2.166-2.465,4.083.039,1.693,3.191,4.259,3.76,3.723.55-.519-1.691-2.71-1.752-4.1C8.406,5.875,9.33,3.885,8.927,3.612Zm6.145,17.14c.4.274,2.509-2.166,2.465-4.083-.039-1.693-3.191-4.259-3.76-3.723-.55.519,1.691,2.71,1.752,4.1C15.594,18.488,14.67,20.478,15.072,20.752ZM20.9,13.829c.438-.212-.621-3.255-2.3-4.176-1.485-.813-5.284.635-5.1,1.394.174.736,3.193-.11,4.424.53C19.2,12.245,20.462,14.04,20.9,13.829ZM3.1,10.535c-.438.211.621,3.255,2.3,4.176,1.485.813,5.284-.635,5.1-1.394-.174-.736-3.193.11-4.424-.53C4.8,12.118,3.537,10.323,3.1,10.535Zm3.167,8.632c-.036.485,3.13,1.09,4.768.093,1.446-.88,2.093-4.893,1.344-5.117-.724-.217-1.5,2.82-2.671,3.565C8.486,18.486,6.3,18.681,6.266,19.166Z" transform="translate(-3 -3.59)" fill="#2a96ff"/>
                          </svg>

                      </span>
                        <div class="Opportunits">
                          <span >Réclamations</span>
                        </div>
                      </div>
                      </div>
                      <div class="col-3"></div>
                      </div>

                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div    class="row" style="margin-top: 15px">
                    <app-filter-reclamation-ticket></app-filter-reclamation-ticket>
                  </div>
                </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div> -->

      </div>

    </div>


  </div>
</form>
